"use strict";
// Auto-generated from rms-cloud-api-settings-schema-2.0.0.json — do not edit manually.
// Re-generate with: node device-settings/tools/generateSonySettingsSchema.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.SonyExtendedControlSettingsSchema = void 0;
const zod_1 = require("zod");
const SonySettingsBaseSchema = zod_1.z
    .object({
    'rs232c-control': zod_1.z
        .object({ value: zod_1.z.union([zod_1.z.boolean(), zod_1.z.enum(['Off', 'Standard', 'VDA'])]).default('Standard') })
        .strict()
        .optional(),
    'picture-mode-hdmi1': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Graphics', 'Photo', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Graphics", "Photo", "Custom')
        .optional(),
    'auto-picture-mode-enabled-hdmi1': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'light-sensor-enabled-hdmi1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-hdmi1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-light-enabled-hdmi1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-hdmi1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-hdmi1': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-hdmi2': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Graphics', 'Photo', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Graphics", "Photo", "Custom')
        .optional(),
    'auto-picture-mode-enabled-hdmi2': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'light-sensor-enabled-hdmi2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-hdmi2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-hdmi2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-hdmi2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-hdmi2': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-hdmi3': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Graphics', 'Photo', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Graphics", "Photo", "Custom')
        .optional(),
    'auto-picture-mode-enabled-hdmi3': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'light-sensor-enabled-hdmi3': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-hdmi3': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-hdmi3': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-hdmi3': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-hdmi3': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-hdmi4': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Graphics', 'Photo', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Graphics", "Photo", "Custom')
        .optional(),
    'auto-picture-mode-enabled-hdmi4': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'light-sensor-enabled-hdmi4': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-hdmi4': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-hdmi4': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-hdmi4': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-hdmi4': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-video1': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Custom')
        .optional(),
    'light-sensor-enabled-video1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-video1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-video1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-video1': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-video1': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-video2': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Custom')
        .optional(),
    'light-sensor-enabled-video2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-video2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-video2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-video2': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-video2': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-app-video': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Custom')
        .optional(),
    'light-sensor-enabled-app-video': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-app-video': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-app-video': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-app-video': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-app-video': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-app-photo': zod_1.z
        .object({ value: zod_1.z.literal('Photo').default('Photo') })
        .strict()
        .describe('Power consumption may increase at: Photo')
        .optional(),
    'light-sensor-enabled-app-photo': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-app-photo': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-app-photo': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-app-photo': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-app-photo': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-app-game': zod_1.z
        .object({ value: zod_1.z.enum(['Game', 'Graphics']).default('Game') })
        .strict()
        .describe('Power consumption may increase at: Game", "Graphics')
        .optional(),
    'light-sensor-enabled-app-game': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-app-game': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-app-game': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-app-game': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-app-game': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'picture-mode-app-general': zod_1.z
        .object({ value: zod_1.z.enum(['Vivid', 'Standard', 'Cinema', 'Game', 'Graphics', 'Photo', 'Custom']).default('Standard') })
        .strict()
        .describe('Power consumption may increase at: Vivid", "Standard", "Cinema", "Game", "Graphics", "Photo", "Custom')
        .optional(),
    'light-sensor-enabled-app-general': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .describe('Power consumption may increase at: false')
        .optional(),
    'ambient-light-sensor-enabled-app-general': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-light-enabled-app-general': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ambient-light-sensor-gamma-enabled-app-general': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'brightness-app-general': zod_1.z
        .object({ value: zod_1.z.number().int().gte(0).lte(50).default(35) })
        .strict()
        .describe('Power consumption may increase at: 0')
        .optional(),
    'ip-assignment': zod_1.z
        .object({ value: zod_1.z.enum(['DHCP', 'Static']).default('DHCP') })
        .strict()
        .optional(),
    'ipv4-address': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$'))
            .default('192.168.1.128'),
    })
        .strict()
        .optional(),
    'ipv4-prefix-length': zod_1.z
        .object({ value: zod_1.z.number().int().gte(8).lte(32).default(24) })
        .strict()
        .optional(),
    'ipv4-gateway': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$|^$'))
            .default('192.168.1.1'),
    })
        .strict()
        .optional(),
    'ipv4-dns-servers': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(?:((?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5]))(?:,((?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])))?)?$|^$'))
            .default('8.8.8.8,8.8.4.4'),
    })
        .strict()
        .optional(),
    'proxy-enabled': zod_1.z
        .object({ value: zod_1.z.enum(['None', 'Static']).default('None') })
        .strict()
        .optional(),
    'proxy-host': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('proxy.example.com') })
        .strict()
        .optional(),
    'proxy-port': zod_1.z
        .object({ value: zod_1.z.number().int().gte(1).lte(65535).default(8080) })
        .strict()
        .optional(),
    'proxy-exclusive-list': zod_1.z
        .object({ value: zod_1.z.string().default('example.com,mycomp.test.com,localhost') })
        .strict()
        .optional(),
    'wifi-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'wifi-ssid': zod_1.z
        .object({ value: zod_1.z.string().min(1).max(32).default('') })
        .strict()
        .optional(),
    'wifi-security': zod_1.z
        .object({ value: zod_1.z.enum(['None', 'Wep', 'Wpa']).default('None') })
        .strict()
        .optional(),
    'wifi-wep-value': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^[\\x20-\\x7E]+$')).default('') })
        .strict()
        .optional(),
    'wifi-wpa-value': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^[\\x20-\\x7E]+$')).min(8).max(63).default('') })
        .strict()
        .optional(),
    'wifi-connected': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'wifi-ip-assignment': zod_1.z
        .object({ value: zod_1.z.enum(['DHCP', 'Static']).default('DHCP') })
        .strict()
        .optional(),
    'wifi-ipv4-address': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$'))
            .default('192.168.1.128'),
    })
        .strict()
        .optional(),
    'wifi-ipv4-prefix-length': zod_1.z
        .object({ value: zod_1.z.number().int().gte(8).lte(32).default(24) })
        .strict()
        .optional(),
    'wifi-ipv4-gateway': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$|^$'))
            .default('192.168.1.1'),
    })
        .strict()
        .optional(),
    'wifi-ipv4-dns-servers': zod_1.z
        .object({
        value: zod_1.z
            .string()
            .regex(new RegExp('^(?:((?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5]))(?:,((?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(?:\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])))?)?$|^$'))
            .default('8.8.8.8,8.8.4.4'),
    })
        .strict()
        .optional(),
    'wifi-proxy-enabled': zod_1.z
        .object({ value: zod_1.z.enum(['None', 'Static']).default('None') })
        .strict()
        .optional(),
    'wifi-proxy-host': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('proxy.example.com') })
        .strict()
        .optional(),
    'wifi-proxy-port': zod_1.z
        .object({ value: zod_1.z.number().int().gte(1).lte(65535).default(8080) })
        .strict()
        .optional(),
    'wifi-proxy-exclusive-list': zod_1.z
        .object({ value: zod_1.z.string().default('example.com,mycomp.test.com,localhost') })
        .strict()
        .optional(),
    'ip-control-authentication': zod_1.z
        .object({ value: zod_1.z.enum(['Normal', 'None', 'PSK', 'Normal PSK']).default('Normal') })
        .strict()
        .optional(),
    'ip-control-authentication-psk': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'simple-ip-control-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'control4-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'system-software-update-automatically-check': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'device-name': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'power-saving': zod_1.z
        .object({ value: zod_1.z.enum(['Off', 'Low', 'High']).default('Off') })
        .strict()
        .describe('Power consumption may increase at: Off')
        .optional(),
    'idle-tv-standby': zod_1.z
        .object({ value: zod_1.z.enum(['15min', '30min', '1h', '2h', '4h', '8h', '12h', '24h', 'Never']).default('4h') })
        .strict()
        .describe('Power consumption may increase at: 8h", "12h", "24h", "Never')
        .optional(),
    'auto-shut-off-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'stay-awake-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'time-zone': zod_1.z
        .object({ value: zod_1.z.enum(['Auto', 'GreenwichMeanTime', 'Tokyo']).default('Auto') })
        .strict()
        .optional(),
    language: zod_1.z
        .object({
        value: zod_1.z
            .enum([
            'af-ZA',
            'az-AZ',
            'bs-BA',
            'ca-ES',
            'cs-CZ',
            'da-DK',
            'de-DE',
            'de-LI',
            'de-AT',
            'de-CH',
            'et-EE',
            'en-AU',
            'en-CA',
            'en-IN',
            'en-NZ',
            'en-SG',
            'en-GB',
            'en-US',
            'en-XC',
            'es-ES',
            'es-US',
            'es-MX',
            'eu-ES',
            'fil-PH',
            'fr-BE',
            'fr-CA',
            'fr-FR',
            'fr-CH',
            'gl-ES',
            'hr-HR',
            'in-ID',
            'zu-ZA',
            'is-IS',
            'it-IT',
            'it-CH',
            'sw-TZ',
            'lv-LV',
            'lt-LT',
            'hu-HU',
            'ms-MY',
            'nl-BE',
            'nl-NL',
            'nb-NO',
            'uz-UZ',
            'pl-PL',
            'pt-BR',
            'pt-PT',
            'ro-RO',
            'sq-AL',
            'sk-SK',
            'sl-SI',
            'sr-Latn-RS',
            'fi-FI',
            'sv-SE',
            'vi-VN',
            'tr-TR',
            'el-GR',
            'be-BY',
            'bg-BG',
            'ky-KG',
            'kk-KZ',
            'mk-MK',
            'mn-MN',
            'ru-RU',
            'sr-RS',
            'uk-UA',
            'iw-IL',
            'ur-PK',
            'ar-EG',
            'fa-IR',
            'am-ET',
            'ne-NP',
            'mr-IN',
            'hi-IN',
            'as-IN',
            'bn-BD',
            'pa-IN',
            'gu-IN',
            'or-IN',
            'ta-IN',
            'te-IN',
            'kn-IN',
            'ml-IN',
            'th-TH',
            'lo-LA',
            'my-MM',
            'ko-KR',
            'zh-CN',
            'zh-HK',
            'zh-TW',
            'ja-JP',
        ])
            .default('en-US'),
    })
        .strict()
        .optional(),
    'bluetooth-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ac-power-on': zod_1.z
        .object({ value: zod_1.z.enum(['Standard', 'AlwaysOn', 'AlwaysStandby']).default('Standard') })
        .strict()
        .optional(),
    'pc-input-optimization-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'wake-up-on-signal': zod_1.z
        .object({
        value: zod_1.z.union([zod_1.z.boolean(), zod_1.z.enum(['Disable', 'AlwaysEnabled', 'InputChangeOnly', 'SpecifiedHours'])]).default('Disable'),
    })
        .strict()
        .optional(),
    'wake-up-on-signal-detect-start-time': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$')).default('00:00') })
        .strict()
        .describe('Setting values must satisfy the following relationship.')
        .optional(),
    'wake-up-on-signal-detect-end-time': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$')).default('00:00') })
        .strict()
        .describe('Setting values must satisfy the following relationship.')
        .optional(),
    'home-key-behavior': zod_1.z
        .object({ value: zod_1.z.union([zod_1.z.boolean(), zod_1.z.enum(['Standard', 'Custom', 'Toggle', 'Disabled', 'HomeMenu'])]).default('Standard') })
        .strict()
        .optional(),
    'custom-home-uri': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('') })
        .strict()
        .optional(),
    'ntp-server': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'pro-mode-lock': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^(?:(?!0000$)\\d{4}|)$|^$')).default('') })
        .strict()
        .optional(),
    'charge-usb-during-standby-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .describe('Power consumption may increase at: true')
        .optional(),
    'import-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'install-bpk-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'launch-web-app-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'web-apps-installation-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'font-scale': zod_1.z
        .object({ value: zod_1.z.number().multipleOf(0.01).gte(0.25).lte(5).default(1) })
        .strict()
        .optional(),
    'initial-input-source': zod_1.z
        .object({ value: zod_1.z.enum(['Default', 'ExternalInput', 'StartupApp', 'AndroidApps']).default('Default') })
        .strict()
        .optional(),
    'initial-input-source-external-input': zod_1.z
        .object({ value: zod_1.z.enum(['hdmi1', 'hdmi2', 'hdmi3', 'hdmi4', 'video1']).default('hdmi1') })
        .strict()
        .optional(),
    'initial-input-source-startup-app-uri': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('') })
        .strict()
        .optional(),
    'initial-input-source-android-app-package': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('') })
        .strict()
        .optional(),
    'initial-input-source-android-app-activity': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^.+$')).default('') })
        .strict()
        .optional(),
    'initial-input-source-android-app-intent-data': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'initial-input-source-android-app-intent-extra-key': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'initial-input-source-android-app-intent-extra-value': zod_1.z
        .object({ value: zod_1.z.string().default('') })
        .strict()
        .optional(),
    'power-scheduling': zod_1.z
        .object({ value: zod_1.z.enum(['Daily', 'Weekly', 'Off']).default('Off') })
        .strict()
        .optional(),
    'power-scheduling-on-time': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$')).default('00:00') })
        .strict()
        .describe('Setting values must satisfy the following relationship.')
        .optional(),
    'power-scheduling-off-time': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$')).default('00:00') })
        .strict()
        .describe('Setting values must satisfy the following relationship.')
        .optional(),
    'power-scheduling-weekly': zod_1.z
        .object({
        value: zod_1.z
            .array(zod_1.z.enum(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']))
            .min(1)
            .refine((arr) => arr.every((item, i) => arr.indexOf(item) === i), 'All items must be unique!'),
    })
        .strict()
        .describe('At least one day of the week must be selected.')
        .optional(),
    'periodic-restart': zod_1.z
        .object({ value: zod_1.z.enum(['Daily', 'Weekly', 'Off']).default('Off') })
        .strict()
        .optional(),
    'periodic-restart-time': zod_1.z
        .object({ value: zod_1.z.string().regex(new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$')).default('00:00') })
        .strict()
        .optional(),
    'periodic-restart-weekly': zod_1.z
        .object({
        value: zod_1.z
            .array(zod_1.z.enum(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']))
            .min(1)
            .refine((arr) => arr.every((item, i) => arr.indexOf(item) === i), 'All items must be unique!'),
    })
        .strict()
        .describe('At least one day of the week must be selected.')
        .optional(),
    'periodic-restart-force': zod_1.z
        .object({ value: zod_1.z.boolean().default(false) })
        .strict()
        .optional(),
    'display-key-control-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'ir-remote-control-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'bluetooth-remote-control-enabled': zod_1.z
        .object({ value: zod_1.z.boolean().default(true) })
        .strict()
        .optional(),
    'external-input-restriction-hdmi1': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'external-input-restriction-hdmi2': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'external-input-restriction-hdmi3': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'external-input-restriction-hdmi4': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'external-input-restriction-video1': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'external-input-restriction-video2': zod_1.z
        .object({ value: zod_1.z.enum(['UseWithLabels', 'UseWithoutLabels', 'NotUse']).default('UseWithLabels') })
        .strict()
        .optional(),
    'enabled-apps': zod_1.z
        .object({
        value: zod_1.z.array(zod_1.z.object({
            packageName: zod_1.z.string(),
            appName: zod_1.z.string(),
            availableValues: zod_1.z.array(zod_1.z.enum(['enabled', 'limited-enabled', 'disabled'])).optional(),
            value: zod_1.z.enum(['enabled', 'limited-enabled', 'disabled']),
        })),
    })
        .strict()
        .optional(),
})
    .strict();
exports.SonyExtendedControlSettingsSchema = SonySettingsBaseSchema.partial().superRefine((data, ctx) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21;
    if (data['ambient-light-sensor-light-enabled-hdmi1'] && !data['ambient-light-sensor-enabled-hdmi1']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-enabled-hdmi1" is required when "ambient-light-sensor-light-enabled-hdmi1" is present',
            path: ['ambient-light-sensor-enabled-hdmi1'],
        });
    }
    if (data['ambient-light-sensor-gamma-enabled-hdmi1'] && !data['ambient-light-sensor-enabled-hdmi1']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-enabled-hdmi1" is required when "ambient-light-sensor-gamma-enabled-hdmi1" is present',
            path: ['ambient-light-sensor-enabled-hdmi1'],
        });
    }
    if (((_a = data['ambient-light-sensor-enabled-hdmi2']) === null || _a === void 0 ? void 0 : _a.value) === true && !data['ambient-light-sensor-light-enabled-hdmi2']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-hdmi2" is required when "ambient-light-sensor-enabled-hdmi2" is "true"',
            path: ['ambient-light-sensor-light-enabled-hdmi2'],
        });
    }
    if (((_b = data['ambient-light-sensor-enabled-hdmi2']) === null || _b === void 0 ? void 0 : _b.value) === true && !data['ambient-light-sensor-gamma-enabled-hdmi2']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-hdmi2" is required when "ambient-light-sensor-enabled-hdmi2" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-hdmi2'],
        });
    }
    if (((_c = data['ambient-light-sensor-enabled-hdmi3']) === null || _c === void 0 ? void 0 : _c.value) === true && !data['ambient-light-sensor-light-enabled-hdmi3']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-hdmi3" is required when "ambient-light-sensor-enabled-hdmi3" is "true"',
            path: ['ambient-light-sensor-light-enabled-hdmi3'],
        });
    }
    if (((_d = data['ambient-light-sensor-enabled-hdmi3']) === null || _d === void 0 ? void 0 : _d.value) === true && !data['ambient-light-sensor-gamma-enabled-hdmi3']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-hdmi3" is required when "ambient-light-sensor-enabled-hdmi3" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-hdmi3'],
        });
    }
    if (((_e = data['ambient-light-sensor-enabled-hdmi4']) === null || _e === void 0 ? void 0 : _e.value) === true && !data['ambient-light-sensor-light-enabled-hdmi4']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-hdmi4" is required when "ambient-light-sensor-enabled-hdmi4" is "true"',
            path: ['ambient-light-sensor-light-enabled-hdmi4'],
        });
    }
    if (((_f = data['ambient-light-sensor-enabled-hdmi4']) === null || _f === void 0 ? void 0 : _f.value) === true && !data['ambient-light-sensor-gamma-enabled-hdmi4']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-hdmi4" is required when "ambient-light-sensor-enabled-hdmi4" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-hdmi4'],
        });
    }
    if (((_g = data['ambient-light-sensor-enabled-video1']) === null || _g === void 0 ? void 0 : _g.value) === true && !data['ambient-light-sensor-light-enabled-video1']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-video1" is required when "ambient-light-sensor-enabled-video1" is "true"',
            path: ['ambient-light-sensor-light-enabled-video1'],
        });
    }
    if (((_h = data['ambient-light-sensor-enabled-video1']) === null || _h === void 0 ? void 0 : _h.value) === true && !data['ambient-light-sensor-gamma-enabled-video1']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-video1" is required when "ambient-light-sensor-enabled-video1" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-video1'],
        });
    }
    if (((_j = data['ambient-light-sensor-enabled-video2']) === null || _j === void 0 ? void 0 : _j.value) === true && !data['ambient-light-sensor-light-enabled-video2']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-video2" is required when "ambient-light-sensor-enabled-video2" is "true"',
            path: ['ambient-light-sensor-light-enabled-video2'],
        });
    }
    if (((_k = data['ambient-light-sensor-enabled-video2']) === null || _k === void 0 ? void 0 : _k.value) === true && !data['ambient-light-sensor-gamma-enabled-video2']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-video2" is required when "ambient-light-sensor-enabled-video2" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-video2'],
        });
    }
    if (((_l = data['ambient-light-sensor-enabled-app-video']) === null || _l === void 0 ? void 0 : _l.value) === true && !data['ambient-light-sensor-light-enabled-app-video']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-app-video" is required when "ambient-light-sensor-enabled-app-video" is "true"',
            path: ['ambient-light-sensor-light-enabled-app-video'],
        });
    }
    if (((_m = data['ambient-light-sensor-enabled-app-video']) === null || _m === void 0 ? void 0 : _m.value) === true && !data['ambient-light-sensor-gamma-enabled-app-video']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-app-video" is required when "ambient-light-sensor-enabled-app-video" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-app-video'],
        });
    }
    if (((_o = data['ambient-light-sensor-enabled-app-photo']) === null || _o === void 0 ? void 0 : _o.value) === true && !data['ambient-light-sensor-light-enabled-app-photo']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-app-photo" is required when "ambient-light-sensor-enabled-app-photo" is "true"',
            path: ['ambient-light-sensor-light-enabled-app-photo'],
        });
    }
    if (((_p = data['ambient-light-sensor-enabled-app-photo']) === null || _p === void 0 ? void 0 : _p.value) === true && !data['ambient-light-sensor-gamma-enabled-app-photo']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-app-photo" is required when "ambient-light-sensor-enabled-app-photo" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-app-photo'],
        });
    }
    if (((_q = data['ambient-light-sensor-enabled-app-game']) === null || _q === void 0 ? void 0 : _q.value) === true && !data['ambient-light-sensor-light-enabled-app-game']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-app-game" is required when "ambient-light-sensor-enabled-app-game" is "true"',
            path: ['ambient-light-sensor-light-enabled-app-game'],
        });
    }
    if (((_r = data['ambient-light-sensor-enabled-app-game']) === null || _r === void 0 ? void 0 : _r.value) === true && !data['ambient-light-sensor-gamma-enabled-app-game']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-app-game" is required when "ambient-light-sensor-enabled-app-game" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-app-game'],
        });
    }
    if (((_s = data['ambient-light-sensor-enabled-app-general']) === null || _s === void 0 ? void 0 : _s.value) === true && !data['ambient-light-sensor-light-enabled-app-general']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-light-enabled-app-general" is required when "ambient-light-sensor-enabled-app-general" is "true"',
            path: ['ambient-light-sensor-light-enabled-app-general'],
        });
    }
    if (((_t = data['ambient-light-sensor-enabled-app-general']) === null || _t === void 0 ? void 0 : _t.value) === true && !data['ambient-light-sensor-gamma-enabled-app-general']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ambient-light-sensor-gamma-enabled-app-general" is required when "ambient-light-sensor-enabled-app-general" is "true"',
            path: ['ambient-light-sensor-gamma-enabled-app-general'],
        });
    }
    if (((_u = data['ip-assignment']) === null || _u === void 0 ? void 0 : _u.value) === 'Static' && !data['ipv4-address']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ipv4-address" is required when "ip-assignment" is "Static"',
            path: ['ipv4-address'],
        });
    }
    if (((_v = data['ip-assignment']) === null || _v === void 0 ? void 0 : _v.value) === 'Static' && !data['ipv4-prefix-length']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ipv4-prefix-length" is required when "ip-assignment" is "Static"',
            path: ['ipv4-prefix-length'],
        });
    }
    if (((_w = data['proxy-enabled']) === null || _w === void 0 ? void 0 : _w.value) === 'Static' && !data['proxy-host']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"proxy-host" is required when "proxy-enabled" is "Static"',
            path: ['proxy-host'],
        });
    }
    if (((_x = data['proxy-enabled']) === null || _x === void 0 ? void 0 : _x.value) === 'Static' && !data['proxy-port']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"proxy-port" is required when "proxy-enabled" is "Static"',
            path: ['proxy-port'],
        });
    }
    if (((_y = data['wifi-security']) === null || _y === void 0 ? void 0 : _y.value) === 'Wep' && !data['wifi-wep-value']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-wep-value" is required when "wifi-security" is "Wep"',
            path: ['wifi-wep-value'],
        });
    }
    if (((_z = data['wifi-security']) === null || _z === void 0 ? void 0 : _z.value) === 'Wpa' && !data['wifi-wpa-value']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-wpa-value" is required when "wifi-security" is "Wpa"',
            path: ['wifi-wpa-value'],
        });
    }
    if (((_0 = data['wifi-ip-assignment']) === null || _0 === void 0 ? void 0 : _0.value) === 'Static' && !data['wifi-ipv4-address']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-ipv4-address" is required when "wifi-ip-assignment" is "Static"',
            path: ['wifi-ipv4-address'],
        });
    }
    if (((_1 = data['wifi-ip-assignment']) === null || _1 === void 0 ? void 0 : _1.value) === 'Static' && !data['wifi-ipv4-prefix-length']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-ipv4-prefix-length" is required when "wifi-ip-assignment" is "Static"',
            path: ['wifi-ipv4-prefix-length'],
        });
    }
    if (((_2 = data['wifi-proxy-enabled']) === null || _2 === void 0 ? void 0 : _2.value) === 'Static' && !data['wifi-proxy-host']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-proxy-host" is required when "wifi-proxy-enabled" is "Static"',
            path: ['wifi-proxy-host'],
        });
    }
    if (((_3 = data['wifi-proxy-enabled']) === null || _3 === void 0 ? void 0 : _3.value) === 'Static' && !data['wifi-proxy-port']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wifi-proxy-port" is required when "wifi-proxy-enabled" is "Static"',
            path: ['wifi-proxy-port'],
        });
    }
    if (data['ip-control-authentication-psk'] && !data['ip-control-authentication']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"ip-control-authentication" is required when "ip-control-authentication-psk" is present',
            path: ['ip-control-authentication'],
        });
    }
    if (((_4 = data['wake-up-on-signal']) === null || _4 === void 0 ? void 0 : _4.value) === 'SpecifiedHours' && !data['wake-up-on-signal-detect-start-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wake-up-on-signal-detect-start-time" is required when "wake-up-on-signal" is "SpecifiedHours"',
            path: ['wake-up-on-signal-detect-start-time'],
        });
    }
    if (((_5 = data['wake-up-on-signal']) === null || _5 === void 0 ? void 0 : _5.value) === 'SpecifiedHours' && !data['wake-up-on-signal-detect-end-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"wake-up-on-signal-detect-end-time" is required when "wake-up-on-signal" is "SpecifiedHours"',
            path: ['wake-up-on-signal-detect-end-time'],
        });
    }
    if (((_6 = data['home-key-behavior']) === null || _6 === void 0 ? void 0 : _6.value) === 'Custom' && !data['custom-home-uri']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"custom-home-uri" is required when "home-key-behavior" is "Custom"',
            path: ['custom-home-uri'],
        });
    }
    if (((_7 = data['home-key-behavior']) === null || _7 === void 0 ? void 0 : _7.value) === 'Toggle' && !data['custom-home-uri']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"custom-home-uri" is required when "home-key-behavior" is "Toggle"',
            path: ['custom-home-uri'],
        });
    }
    if (((_8 = data['initial-input-source']) === null || _8 === void 0 ? void 0 : _8.value) === 'ExternalInput' && !data['initial-input-source-external-input']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"initial-input-source-external-input" is required when "initial-input-source" is "ExternalInput"',
            path: ['initial-input-source-external-input'],
        });
    }
    if (((_9 = data['initial-input-source']) === null || _9 === void 0 ? void 0 : _9.value) === 'StartupApp' && !data['initial-input-source-startup-app-uri']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"initial-input-source-startup-app-uri" is required when "initial-input-source" is "StartupApp"',
            path: ['initial-input-source-startup-app-uri'],
        });
    }
    if (((_10 = data['initial-input-source']) === null || _10 === void 0 ? void 0 : _10.value) === 'AndroidApps' && !data['initial-input-source-android-app-package']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"initial-input-source-android-app-package" is required when "initial-input-source" is "AndroidApps"',
            path: ['initial-input-source-android-app-package'],
        });
    }
    if (((_11 = data['initial-input-source']) === null || _11 === void 0 ? void 0 : _11.value) === 'AndroidApps' && !data['initial-input-source-android-app-activity']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"initial-input-source-android-app-activity" is required when "initial-input-source" is "AndroidApps"',
            path: ['initial-input-source-android-app-activity'],
        });
    }
    if (((_12 = data['power-scheduling']) === null || _12 === void 0 ? void 0 : _12.value) === 'Daily' && !data['power-scheduling-on-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"power-scheduling-on-time" is required when "power-scheduling" is "Daily"',
            path: ['power-scheduling-on-time'],
        });
    }
    if (((_13 = data['power-scheduling']) === null || _13 === void 0 ? void 0 : _13.value) === 'Daily' && !data['power-scheduling-off-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"power-scheduling-off-time" is required when "power-scheduling" is "Daily"',
            path: ['power-scheduling-off-time'],
        });
    }
    if (((_14 = data['power-scheduling']) === null || _14 === void 0 ? void 0 : _14.value) === 'Weekly' && !data['power-scheduling-on-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"power-scheduling-on-time" is required when "power-scheduling" is "Weekly"',
            path: ['power-scheduling-on-time'],
        });
    }
    if (((_15 = data['power-scheduling']) === null || _15 === void 0 ? void 0 : _15.value) === 'Weekly' && !data['power-scheduling-off-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"power-scheduling-off-time" is required when "power-scheduling" is "Weekly"',
            path: ['power-scheduling-off-time'],
        });
    }
    if (((_16 = data['power-scheduling']) === null || _16 === void 0 ? void 0 : _16.value) === 'Weekly' && !data['power-scheduling-weekly']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"power-scheduling-weekly" is required when "power-scheduling" is "Weekly"',
            path: ['power-scheduling-weekly'],
        });
    }
    if (((_17 = data['periodic-restart']) === null || _17 === void 0 ? void 0 : _17.value) === 'Daily' && !data['periodic-restart-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"periodic-restart-time" is required when "periodic-restart" is "Daily"',
            path: ['periodic-restart-time'],
        });
    }
    if (((_18 = data['periodic-restart']) === null || _18 === void 0 ? void 0 : _18.value) === 'Daily' && !data['periodic-restart-force']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"periodic-restart-force" is required when "periodic-restart" is "Daily"',
            path: ['periodic-restart-force'],
        });
    }
    if (((_19 = data['periodic-restart']) === null || _19 === void 0 ? void 0 : _19.value) === 'Weekly' && !data['periodic-restart-time']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"periodic-restart-time" is required when "periodic-restart" is "Weekly"',
            path: ['periodic-restart-time'],
        });
    }
    if (((_20 = data['periodic-restart']) === null || _20 === void 0 ? void 0 : _20.value) === 'Weekly' && !data['periodic-restart-weekly']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"periodic-restart-weekly" is required when "periodic-restart" is "Weekly"',
            path: ['periodic-restart-weekly'],
        });
    }
    if (((_21 = data['periodic-restart']) === null || _21 === void 0 ? void 0 : _21.value) === 'Weekly' && !data['periodic-restart-force']) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: '"periodic-restart-force" is required when "periodic-restart" is "Weekly"',
            path: ['periodic-restart-force'],
        });
    }
});
